export const locationPath = 'location'
export const autoDetectPath = 'auto-detect'
export const manualDetectPath = 'manual-detect'
